<template>
  <div>
    <div class="login-wrapper">
      <div class="content">
        <login-register-form
          :prop-action="action"
          @isLogin="isLogin"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LoginRegisterForm from '@/components/LoginRegisterForm.vue'
import { postMessage } from '~/utils/appPostMessage'
export default {
  auth: false,
  components: {
    LoginRegisterForm
  },
  beforeRouteLeave (to, from, next) {
    if (this.loginType === 'login' && !this.loginSuccess) {
      this.$gtm.push({ event: 'loginLeave' })
    } else if (this.loginType === 'register' && !this.registerSuccess) {
      this.$gtm.push({ event: 'registerLeave' })
    }
    next()
  },
  middleware: 'postRequest',
  meta: {
    mobileBanner: false
  },
  async asyncData ({ params, redirect, $router }) {
    const { action } = params
    if (!['login', 'register', 'forgotPassword', 'setPassword'].includes(action)) {
      redirect({ name: 'auth-action', params: { action: 'login' } })
    }
    return { action }
  },
  data () {
    return {
      title: '會員登入',
      isMobile: null,
      loginType: null,
      loginSuccess: false,
      registerSuccess: false,
      /** 限 login, register, forgotPassword, setPassword */
      action: ''
    }
  },
  head () {
    return {
      title: this.title,
      meta: [
        { hid: 'title', property: 'title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'og:title', property: 'og:title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'twitter:title', property: 'twitter:title', content: this.title + this.$store.state.meta.titleTemple }
      ]
    }
  },
  async mounted () {
    this.isMobile = screen.width <= 768
    if (process.client && this.$auth.loggedIn) {
      const toRoute = this.$auth.$storage.getState('toRoute') || { name: 'member-accountSetting' }
      console.log('toRoute', toRoute)
      this.$nuxt.$router.replace(toRoute)
    }
  },
  methods: {
    async isLogin (prop) {
      if (prop === 'register') {
        this.registerSuccess = true
        // await this.$nuxt.$router.replace('/')
        // await this.$store.dispatch('registerSuccess', {isOpen: true, scrollTop: true})
        this.$gtm.push({
          event: 'userRegister',
          pageTitle: document.title,
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name
        })
        console.log(this.$auth.$storage.getState('toRoute'))
        let toRoute = this.$auth.$storage.getState('toRoute') || { name: 'member-accountSetting' }
        if (sessionStorage.getItem('toRoute')) {
          toRoute = JSON.parse(sessionStorage.getItem('toRoute'))
          sessionStorage.removeItem('toRoute')
        }
        if (sessionStorage.getItem('serviceData')) {
          sessionStorage.setItem('serviceData', JSON.stringify({
            ...JSON.parse(sessionStorage.getItem('serviceData')),
            isLogined: true
          }))
        }
        this.$nuxt.$router.replace(toRoute)
        this.$auth.$storage.removeState('toRoute')
        await this.$store.dispatch('registerSuccess', { isOpen: true, scrollTop: true })
      } else {
        this.loginSuccess = true
        this.$gtm.push({
          event: 'userLogin',
          pageTitle: document.title,
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name
        })
        const redirectRoutePath = this.$route.query.redirect
        let toRoute = this.$auth.$storage.getState('toRoute') || redirectRoutePath || { name: 'member-accountSetting' }
        if (sessionStorage.getItem('toRoute')) {
          toRoute = JSON.parse(sessionStorage.getItem('toRoute'))
          sessionStorage.removeItem('toRoute')
        } else if (redirectRoutePath) {
          toRoute = redirectRoutePath
        }
        if (sessionStorage.getItem('serviceData')) {
          sessionStorage.setItem('serviceData', JSON.stringify({
            ...JSON.parse(sessionStorage.getItem('serviceData')),
            isLogined: true
          }))
        }
        this.$nuxt.$router.replace(toRoute)
        this.$auth.$storage.removeState('toRoute')
        this.$store.dispatch('order/checkHasOrderIsQuotedAndUnread')
      }
      if (this.$store.state.isApp) {
        const appTokenData = await this.$store.dispatch('getAppToken')
        console.log('appTokenData', appTokenData)
        if (appTokenData && postMessage) {
          const postMessageData = {
            type: 'ecWebToken',
            AccessToken: appTokenData.AccessToken,
            RefreshToken: appTokenData.RefreshToken,
            CreateDate: appTokenData.CreateDate,
            AccessTokenExpireDate: appTokenData.AccessTokenExpireDate,
            RefreshTokenExpireDate: appTokenData.RefreshTokenExpireDate
          }
          console.log('postMessageData', postMessageData)
          postMessage(postMessageData)
        }
      }

      if (this.$nuxt.$route.query.toAppPage) {
        const toAppPage = this.$nuxt.$route.query.toAppPage
        const serviceId = this.$nuxt.$route.query.serviceId || ''
        console.log('toAppPage', toAppPage, serviceId)
        window.location.href = `${process.env.IN_APP_AD_URL}?page=${toAppPage}&params1=${serviceId}&referrer=`
      }

      if (this.$nuxt.$route.query.redirect) {
        this.$router.push(this.$nuxt.$route.query.redirect)
      }
    },
    switchLoginType (type) {
      this.loginType = type
    }
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
  height: initial;
  min-height: inherit;
  background-image: url('../../assets/image/login_bg.png');
  background-position: center;
  background-size: cover;

  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.content {
  width: 100%;
  background: white;
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .content {
    height: calc(var(--vh, 1vh) * 100 - #{$headerHeightMobile});
    box-sizing: border-box;
  }
}

/** 手機以上 */
@media screen and (min-width: $mobileWidth) {
  .content {
    max-width: 530px;
    margin: 40px 80px 40px;
    padding: 15px 30px 32px;
    border-radius: 24px;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.3);
  }
}
</style>
